import dayjs, { Dayjs } from "dayjs";

/**
 * To get the ISO8601 representation of the date
 * @param date date in either type Dayjs, string or undefined
 * @returns ISO8601 representation of the date if it's a valid date
 */
export const getISODateString = (date: Dayjs | string | undefined): string | null => {
  if (!date) {
    return null;
  } else if (dayjs.isDayjs(date)) {
    return new Date(date.format("YYYY-MM-DD")).toISOString();
  } else if (typeof date === "string" && dayjs(date, undefined, true).isValid()) {
    return new Date(dayjs(date).format("YYYY-MM-DD")).toISOString();
  }else{
    return null;
  }
};
